export const publisherListFactory = (): { label: string; value: string }[] => {
	return [
		{
			value: '천재교육',
			label: '천재교육',
		},
		{
			value: 'YBM',
			label: 'YBM',
		},
		{
			value: 'NE능률',
			label: 'NE능률',
		},
		{
			value: '동아출판사',
			label: '동아출판사',
		},
		{
			value: '지학사',
			label: '지학사',
		},
		{
			value: '더멘토',
			label: '더멘토',
		},
		{
			value: '미래엔',
			label: '미래엔',
		},
		{
			value: '금성출판사',
			label: '금성출판사',
		},
		{
			value: '해냄에듀',
			label: '해냄에듀',
		},
		{
			value: '다락원',
			label: '다락원',
		},
		{
			value: '교학사',
			label: '교학사',
		},
		{
			value: '창비',
			label: '창비',
		},
		{
			value: '좋은책신사고',
			label: '좋은책신사고',
		},
		{
			value: '개념원리',
			label: '개념원리',
		},
		{
			value: 'EBS한국교육방송공사',
			label: 'EBS한국교육방송공사',
		},
		{
			value: '수경출판사',
			label: '수경출판사',
		},
		{
			value: '골드교육',
			label: '골드교육',
		},
		{
			value: '기탄교육',
			label: '기탄교육',
		},
		{
			value: '길벗',
			label: '길벗',
		},
		{
			value: '대교',
			label: '대교',
		},
		{
			value: '디딤돌교육',
			label: '디딤돌교육',
		},
		{
			value: '마더텅',
			label: '마더텅',
		},
		{
			value: '마플',
			label: '마플',
		},
		{
			value: '메가스터디',
			label: '메가스터디',
		},
		{
			value: '성지출판사',
			label: '성지출판사',
		},
		{
			value: '쎄듀',
			label: '쎄듀',
		},
		{
			value: '쏠티북스',
			label: '쏠티북스',
		},
		{
			value: '아름다운샘',
			label: '아름다운샘',
		},
		{
			value: '에이급출판사',
			label: '에이급출판사',
		},
		{
			value: '오르비북스',
			label: '오르비북스',
		},
		{
			value: '이룸이앤비',
			label: '이룸이앤비',
		},
		{
			value: '이투스북',
			label: '이투스북',
		},
		{
			value: '진학사',
			label: '키출판사',
		},
		{
			value: '해커스',
			label: '해커스',
		},
	]
}
